import { PrimeReactModal } from "@finanedi.es/storybook"
import { Dropdown } from "primereact/dropdown"
import { useState } from "react"
import { ModalFooter } from "./ModalFooter"
import { ModalLogo } from "./ModalLogo"
import { PRIME_REACT_MODAL_DEFAULT_PROPS, STATE } from "./_constants"
import { StepTwoModalProps } from "./_interfaces"

export function StepTwoModal({
  firstConfirm,
  form,
  bankSelected,
  onStepTwoConfirm,
  connectingData,
  setConnectingData,
}: StepTwoModalProps) {
  const [accountSelected, setAccountSelected] = useState<number | undefined>(
    firstConfirm[STATE.GET]?.additionalInfo?.accounts?.[0]?.accountId
  )

  const handleClose = (): void => {
    form[STATE.SET]({})
    firstConfirm[STATE.SET](undefined)
    form[STATE.SET]({})
  }

  return (
    <PrimeReactModal
      className='tw-w-128 tw-max-w-full tw-h-fit tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      ptContext={{
        dialog: PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
        dropdown: PRIME_REACT_MODAL_DEFAULT_PROPS.dropdown,
      }}
      header='Vincular tarjeta'
      footer={
        <ModalFooter
          onCancel={handleClose}
          onConfirm={async () => {
            try {
              form[STATE.SET]((prevData) => ({
                ...prevData,
                accountId:
                  accountSelected ??
                  firstConfirm[STATE.GET]?.additionalInfo?.accounts?.[0]
                    ?.accountId ??
                  "",
              }))
              setConnectingData(true)
              await onStepTwoConfirm?.({
                bankSelected,
                formData: {
                  ...form[STATE.GET],
                  accountId:
                    form[STATE.GET]?.accountId ??
                    firstConfirm[STATE.GET]?.additionalInfo?.accounts?.[0]
                      ?.accountId,
                  service: bankSelected?.service ?? "",
                },
              })
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error("Error connecting bank", error)
            } finally {
              setConnectingData(false)
            }
          }}
          isButtonLoading={connectingData}
        />
      }
      onHide={handleClose}
      closeOnEscape
      focusOnShow={false}
      visible={Boolean(
        firstConfirm[STATE.GET]?.additionalInfo?.accounts?.length
      )}
    >
      <ModalLogo bankSelected={bankSelected} />
      <div className='tw-flex tw-flex-col tw-gap-1'>
        <label htmlFor='accountId'>Selecciona una cuenta</label>
        <Dropdown
          inputId='accountId'
          value={
            accountSelected ??
            firstConfirm[STATE.GET]?.additionalInfo?.accounts?.[0]?.accountId
          }
          options={firstConfirm[STATE.GET]?.additionalInfo?.accounts}
          optionLabel='description'
          optionValue='accountId'
          onChange={(e) => {
            setAccountSelected(e.value)
            form[STATE.SET]((prevData) => ({
              ...prevData,
              accountId: e.value,
            }))
          }}
          panelClassName='!tw-z-[1201]'
        />
      </div>
    </PrimeReactModal>
  )
}
